/* eslint-disable */
import React, {useEffect, useState} from 'react';
import cn from 'classnames';
import {useDispatch, useSelector} from 'react-redux';
import {Route, useHistory, useLocation} from 'react-router-dom';
import moment from 'moment';
import CircularProgress from '@material-ui/core/CircularProgress';
import AppVersion from './components/AppSettings/AppVersion';
import './App.css';
import {Box} from '@material-ui/core';
import Navbar from './components/layout/nav/Navbar';
import {useDatePickerContext} from './components/Datepicker/DatePickerContext';
import GlobalStyle from './global-styles';
import Sidebar from './components/layout/sidebar/Sidebar';
import Index from './routes/App';
import WarningModal from './components/Modals/WarningModal';
import WhatsAppSupportButton from 'components/WhatsAppSupportButton';
import Auth from './routes/Auth';
import {
  AUTH_CHAT_USER,
  AUTH_USER,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS
} from './store/global/auth/action';
import {getStorageToken} from './helpers/localStorage/authStorage';
import Managers from './routes/App/Managers';
import AppVersionNotification from './components/Modals/AppVersionNotification';
import useNetwork from './hooks/useNetwork';
import {SET_NETWORK_CONNECTION} from './store/global/globalNotifications/action';
import {
  CLEAR_ACTIVE_ORDERS,
  RUN_GET_ACTIVE_ORDERS_JOB,
  STOP_GET_ACTIVE_ORDERS_JOB
} from './store/global/orders/action';
import {
  CLEAR_ACTIVE_ORDERS as CLEAR_ACTIVE_ORDERS_V2,
  RUN_GET_ACTIVE_ORDERS_JOB as RUN_GET_ACTIVE_ORDERS_JOB_V2,
  STOP_GET_ACTIVE_ORDERS_JOB as STOP_GET_ACTIVE_ORDERS_JOB_V2
} from './store/global/ordersV2/action';
import {usePrevious} from './hooks/usePrevious';
import {
  CLEAR_BAD_NEW_ACTIVE_ORDERS,
  CLEAR_BAD_NEW_DELIVERED_ORDERS,
  RUN_BAD_DELIVERED_ORDERS_JOB,
  STOP_BAD_DELIVERED_ORDERS_JOB
} from './store/global/bookADriverDelivered/action';
import {ErrorBoundary} from 'react-error-boundary';
import ErrorFallback from './helpers/ErrorCatchPage';
import {hubspotComment} from './helpers/services/api/hubspot';
import HubspotChat from './routes/App/HubspotChat';
import {SET_LOCATION_ID} from './store/global/user/action';
import hubspotChatReducer from './store/global/hubspotChat/reducer';
import {toast} from 'react-toastify';
import {
  GET_USER_INFO_FOR_CHAT,
  GET_USER_INFO_FOR_CHAT_SUCCESS,
  LOAD_CHAT
} from './store/global/hubspotChat/action';
import DeveloperPage from './routes/Developer';
import ConnectingStreamDsp from './routes/App/ConnectingStreamDsp';
import {setSessionStorageItem} from './helpers/sessionStorage';
import ConnectingStreamPos from './routes/App/ConnectingStreamPos';
import {
  normalizePath,
  getPageName,
  findClickableElement
} from './helpers/functionUtils/postHog';
import {PATHS_WITH_REDIRECT} from './helpers/constants/restrictions';
import {saveReturnUrl} from './helpers/functionUtils/returnUrl';

function App() {
  const date = useDatePickerContext();
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const [onlineConnection] = useNetwork();
  const PERMISSIONS = {
    SUPERADMIN: 'sudo',
    USER: 'user',
    AUTH: 'auth',
    CHAT: 'chat',
    DEVELOPER: 'developer',
    STREAM_DSP: 'stream-dsp',
    STREAM_POS: 'stream-pos'
  };
  const {token, fetchingUserData, isAuthenticated} = useSelector(
    (state) => state.authReducer
  );
  const {userData, locationId, locations, activeLocation} = useSelector(
    (state) => state.user
  );
  const [showSidebar, setShowSidebar] = useState(false);

  const hubspotInfo = useSelector((state) => state.hubspotChatReducer);

  const prevLocation = usePrevious(locationId);

  const isLoggedIn =
    date && token && (userData.role === 'sudo' || locationId) && userData.id;
  const getUserAccess = () => {
    if (location.pathname.includes('/hubspot-chat')) {
      return PERMISSIONS.CHAT;
    }
    if (location.pathname.includes('/developer')) {
      return PERMISSIONS.DEVELOPER;
    }
    if (location.pathname.includes('/connecting-stream-dsp')) {
      return PERMISSIONS.STREAM_DSP;
    }
    if (location.pathname.includes('/connecting-stream-pos')) {
      return PERMISSIONS.STREAM_POS;
    }
    if (!isLoggedIn) {
      return PERMISSIONS.AUTH;
    }

    return userData.role === 'sudo' ? PERMISSIONS.SUPERADMIN : PERMISSIONS.USER;
  };

  const runGetNewOrdersJob = () => {
    if (locationId) {
      dispatch(STOP_GET_ACTIVE_ORDERS_JOB());
      dispatch(STOP_GET_ACTIVE_ORDERS_JOB_V2());
      if (activeLocation?.AllowedServiceFeatures?.includes('orders')) {
        dispatch(RUN_GET_ACTIVE_ORDERS_JOB());
      }
      if (
        activeLocation?.AllowedServiceFeatures?.includes('orders_v2') ||
        activeLocation?.AllowedServiceFeatures?.includes('show_byoc_events')
      ) {
        dispatch(RUN_GET_ACTIVE_ORDERS_JOB_V2());
      }
    }
  };
  const runGetNewDeliveredJob = () => {
    if (locationId) {
      dispatch(STOP_BAD_DELIVERED_ORDERS_JOB());
      if (
        activeLocation?.AllowedServiceFeatures?.includes('book_a_driver') ||
        activeLocation?.AllowedServiceFeatures?.includes('book_a_driver_v2')
      ) {
        dispatch(RUN_BAD_DELIVERED_ORDERS_JOB());
      }
    }
  };

  useEffect(() => {
    if (
      (prevLocation &&
        (history.location.pathname.includes('/orders/active') ||
          history.location.pathname.includes('/orders-v2/active'))) ||
      (!history.location.pathname.includes('/orders/active') &&
        !history.location.pathname.includes('/orders-v2/active') &&
        !history.location.pathname.includes('/hubspot-chat'))
    ) {
      if (activeLocation?.AllowedServiceFeatures?.includes('orders')) {
        dispatch(CLEAR_ACTIVE_ORDERS());
      }
      if (
        activeLocation?.AllowedServiceFeatures?.includes('orders_v2') ||
        activeLocation?.AllowedServiceFeatures?.includes('show_byoc_events')
      ) {
        dispatch(CLEAR_ACTIVE_ORDERS_V2());
      }
      runGetNewOrdersJob();
    }
    dispatch(CLEAR_BAD_NEW_DELIVERED_ORDERS());
    dispatch(CLEAR_BAD_NEW_ACTIVE_ORDERS());
    runGetNewDeliveredJob();
  }, [locationId]);

  useEffect(() => {
    dispatch(SET_NETWORK_CONNECTION(onlineConnection));
    if (!onlineConnection) {
      if (activeLocation?.AllowedServiceFeatures?.includes('orders')) {
        dispatch(STOP_GET_ACTIVE_ORDERS_JOB());
      }
      if (
        activeLocation?.AllowedServiceFeatures?.includes('orders_v2') ||
        activeLocation?.AllowedServiceFeatures?.includes('show_byoc_events')
      ) {
        dispatch(STOP_GET_ACTIVE_ORDERS_JOB_V2());
      }
      dispatch(STOP_BAD_DELIVERED_ORDERS_JOB());
    } else if (isLoggedIn) {
      runGetNewOrdersJob();
      runGetNewDeliveredJob();
    }
  }, [onlineConnection]);

  useEffect(() => {
    // TODO: Remove when the old dashboard does not need to be used.
    // For connection with old dashboard, remove all except 'else', revert AUTH_USER action
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const authToken = urlParams.get('token');
    const queryLocationId = urlParams.get('locationId');
    const queryLocationName = urlParams.get('locationName');
    const queryUserEmail = urlParams.get('userEmail');
    const streamState = urlParams.get('state');
    if (queryLocationId) {
      localStorage.setItem('locationId', queryLocationId);
    }
    if (
      history.location.pathname.includes('/hubspot-chat') &&
      authToken &&
      queryLocationId
    ) {
      dispatch(
        GET_USER_INFO_FOR_CHAT_SUCCESS({
          ...(queryUserEmail && {
            userEmail: decodeURIComponent(queryUserEmail)
          }),
          ...(queryLocationName && {
            FullName: decodeURIComponent(queryLocationName)
          })
        })
      );
      dispatch(
        AUTH_CHAT_USER({
          token: authToken,
          fromOldDashboard: true,
          locationId: queryLocationId
        })
      );
      localStorage.setItem('access_token', JSON.stringify(authToken));

      dispatch(LOAD_CHAT(true));
    } else if (
      history.location.pathname.includes('/hubspot-chat') &&
      !authToken
    ) {
      toast.error('Missing token!');
    } else if (
      history.location.pathname.includes('/hubspot-chat') &&
      !queryLocationId
    ) {
      toast.error('Missing location ID');
    }
    // Validation of the jwt token will be possible after deploy and receiving the url
    else if (authToken) {
      const hasLoginToken = history.location.pathname.includes('login_token');
      dispatch(
        AUTH_USER({token: authToken, fromOldDashboard: true, hasLoginToken})
      );
      localStorage.setItem('access_token', JSON.stringify(authToken));
      urlParams.delete('token');
      history.push(window.location.pathname);
    } else {
      const storedTokens = getStorageToken();
      if (storedTokens.refreshToken) {
        if (token || storedTokens.token) {
          dispatch(AUTH_USER({token: token || storedTokens.token}));
        } else {
          if (
            !history.location.pathname.includes('/connecting-stream-dsp') &&
            !history.location.pathname.includes('/connecting-stream-pos')
          ) {
            saveReturnUrl(history.location.pathname + history.location.search);
            dispatch(LOGOUT_USER({preserveReturnUrl: true}));
          } else {
            if (streamState) {
              setSessionStorageItem(
                'streamUrl',
                history.location.pathname + history.location.search
              );
            }
            history.push('/');
          }
        }
      } else {
        if (
          !history.location.pathname.includes('/connecting-stream-dsp') &&
          !history.location.pathname.includes('/connecting-stream-pos')
        ) {
          const returnTo = history.location.pathname + history.location.search;
          dispatch(LOGOUT_USER_SUCCESS());
          const whiteList = [
            '/reset-password/',
            '/sign-up-sales-new',
            '/sign-up',
            '/forgot-password',
            '/activate-member/',
            '/setup'
          ];
          if (
            !whiteList.some((item) => history.location.pathname.includes(item))
          ) {
            saveReturnUrl(returnTo);
            history.push('/');
          }
        } else {
          if (streamState) {
            setSessionStorageItem(
              'streamUrl',
              history.location.pathname + history.location.search
            );
          }
          history.push('/');
        }
      }
    }
  }, []);

  useEffect(() => {
    if (window.HubSpotConversations && locationId) {
      const {FullName, Phone} = locations?.length
        ? locations.filter((el) => el._id === locationId)[0]
        : hubspotInfo;
      const messageText = `Location Name: ${FullName}\nLocation Phone: ${Phone}\nUser Email: ${
        userData?.email || hubspotInfo?.userEmail
      }`;
      window.HubSpotConversations.clear({resetWidget: true});
      window.HubSpotConversations.widget.load();
      window.HubSpotConversations.on('conversationStarted', (payload) =>
        hubspotComment(payload, messageText)
      );
      window.HubSpotConversations.on('widgetLoaded', (payload) => {
        if (history.location.pathname.includes('/hubspot-chat')) {
          window.HubSpotConversations.widget.open();
          dispatch(LOAD_CHAT(false));
        }
      });
    }
  }, [locationId]);

  useEffect(() => {
    if (userData?.id) {
      window.pendo.initialize({
        visitor: {
          id: userData.id // Required if user is logged in
          // email:        // Recommended if using Pendo Feedback, or NPS Email
          // full_name:    // Recommended if using Pendo Feedback
          // role:         // Optional
        }
      });
    }
  }, [userData]);

  useEffect(() => {
    if (window?.posthog && userData?._id) {
      const userName =
        userData?.first_name && userData?.last_name
          ? `${userData.first_name} ${userData.last_name}`
          : userData?.email;
      window?.posthog.identify(userData._id, {
        email: userData.email,
        name: userName,
        role: userData.role
      });
    }
  }, [userData?._id]);

  useEffect(() => {
    const handleGlobalClick = (event) => {
      const res = findClickableElement(event);

      if (!res || !window?.posthog) return;

      window?.posthog.capture('custom_click', {
        element: res.element,
        text: res.text || 'without text',
        to_path: res.toPath || null,
        full_field_text: `clicked ${res.element}${
          res.text ? ` with text ${res.text}` : ''
        }`,
        event: 'click',
        page_url: window.location.pathname,
        page_path: normalizePath(window.location.pathname),
        page_name: getPageName(window.location.pathname),
        timestamp: moment().utc().format()
      });
    };

    document.addEventListener('click', handleGlobalClick, {
      capture: true,
      passive: true
    });

    return () => {
      document.removeEventListener('click', handleGlobalClick, {capture: true});
    };
  }, []);

  useEffect(() => {
    if (!window?.posthog) return;
    const userName =
      userData?.first_name && userData?.last_name
        ? `${userData.first_name} ${userData.last_name}`
        : userData?.email;

    window?.posthog.register({
      location_name: activeLocation?.FullName ?? null,
      location_id: locationId ?? null,
      user_name: userName ?? null,
      user_id: userData?._id ?? null
    });
  }, [window?.posthog, activeLocation?.FullName, locationId, userData?._id]);

  useEffect(() => {
    if (
      window?.posthog &&
      userData?._id &&
      locationId &&
      location?.pathname !== '/' &&
      !PATHS_WITH_REDIRECT.includes(location.pathname)
    ) {
      window?.posthog.capture('$pageview', {
        page_url: location.pathname,
        page_path: normalizePath(location.pathname),
        page_name: getPageName(location.pathname),
        timestamp: moment().utc().format()
      });
    }
  }, [location.pathname]);

  if (fetchingUserData)
    return (
      <Box
        display='flex'
        justifyContent='center'
        alignItems='center'
        height='100vh'
      >
        <CircularProgress className='CircularProgress' />
      </Box>
    );

  return (
    <AppVersion>
      <GlobalStyle />
      <WarningModal />
      <AppVersionNotification />
      {(() => {
        switch (getUserAccess()) {
          case PERMISSIONS.USER:
            return (
              <div
                className={cn('main', {
                  withoutNavigation:
                    !userData.pendingDataSetuped ||
                    [
                      '/my-account/self-setup',
                      '/my-account/sales-setup',
                      '/my-account/sales-setup-new'
                    ].some((el) => history.location.pathname.includes(el))
                })}
              >
                <Navbar
                  showSidebar={showSidebar}
                  setShowSidebar={setShowSidebar}
                />
                <Sidebar
                  showSidebar={showSidebar}
                  setShowSidebar={setShowSidebar}
                />
                <ErrorBoundary
                  FallbackComponent={ErrorFallback}
                  onReset={() => {}}
                >
                  <Index />
                </ErrorBoundary>
                <ErrorBoundary
                  FallbackComponent={() => null}
                  onReset={() => {}}
                >
                  <WhatsAppSupportButton />
                </ErrorBoundary>
              </div>
            );
          case PERMISSIONS.SUPERADMIN:
            return (
              <ErrorBoundary
                FallbackComponent={ErrorFallback}
                onReset={() => {}}
              >
                <Managers />
              </ErrorBoundary>
            );
          case PERMISSIONS.CHAT:
            return (
              <ErrorBoundary
                FallbackComponent={ErrorFallback}
                onReset={() => {}}
              >
                <HubspotChat />
              </ErrorBoundary>
            );
          case PERMISSIONS.DEVELOPER:
            return (
              <ErrorBoundary
                FallbackComponent={ErrorFallback}
                onReset={() => {}}
              >
                <DeveloperPage />
              </ErrorBoundary>
            );
          case PERMISSIONS.STREAM_DSP:
            return (
              <ErrorBoundary
                FallbackComponent={ErrorFallback}
                onReset={() => {}}
              >
                <ConnectingStreamDsp />
              </ErrorBoundary>
            );
          case PERMISSIONS.STREAM_POS:
            return (
              <ErrorBoundary
                FallbackComponent={ErrorFallback}
                onReset={() => {}}
              >
                <ConnectingStreamPos />
              </ErrorBoundary>
            );
          default:
            return (
              <div className='auth-main'>
                <Auth />
              </div>
            );
        }
      })()}
    </AppVersion>
  );
}

export default App;
